import { useContext } from 'react';
import { Link } from 'react-router';

import Image from '@components/Image';
import { AuthorMeta } from '@components/meta';
import Slider from '@components/Slider';
import PARIS_2024_06_02_SELFIE from '@data/photos/other/paris_2024_06_02_selfie';
import ARLES from '@data/series/arles';
import BANGKOK from '@data/series/bangkok';
import BERLIN from '@data/series/berlin';
import CAMBODIA from '@data/series/cambodia';
import LUXE_CITY from '@data/series/luxe_city';
import MUSEUM from '@data/series/museum';
import PARIS_DAY from '@data/series/paris_day';
import PARIS_NIGHT from '@data/series/paris_night';
import ROME from '@data/series/rome';
import { isSeriesCover } from '@utils/index';
import { DataContext } from '@utils/useData';
import { IntlContext } from '@utils/useIntl';

const Home = () => {
  const { translate, translateTrad } = useContext(IntlContext);
  const { photos, series } = useContext(DataContext);

  const homePhotos = [
    photos.find(({ id }) => id === PARIS_2024_06_02_SELFIE.id),
    photos.find(isSeriesCover(PARIS_DAY)),
    photos.find(isSeriesCover(PARIS_NIGHT)),
    photos.find(isSeriesCover(BERLIN)),
    photos.find(isSeriesCover(MUSEUM)),
    photos.find(isSeriesCover(CAMBODIA)),
    photos.find(isSeriesCover(BANGKOK)),
    photos.find(isSeriesCover(ARLES)),
    photos.find(isSeriesCover(ROME)),
    photos.find(isSeriesCover(LUXE_CITY)),
  ];

  return (
    <div className="grow flex items-center">
      <div className="w-full desktop:grid desktop:grid-cols-2 desktop:gap-8">
        <section>
          <Slider
            className="w-full max-w-[600px] aspect-square"
            photos={homePhotos}
            withoutDetails
            withoutMeta
            autoplay
            renderPhoto={(photo) => {
              const photoSeries = photo.seriesIds?.map((id) =>
                series.find((s) => s.id === id),
              );
              const mainSeries = photoSeries ? photoSeries[0] : undefined;

              const img = (
                <Image className="w-full aspect-square mx-auto" photo={photo} />
              );

              return mainSeries ? (
                <Link
                  className="w-full"
                  aria-label={translateTrad(mainSeries.name)}
                  to={
                    mainSeries.location
                      ? `/locations/${mainSeries.location?.zone.toLowerCase()}/${
                          mainSeries.id
                        }`
                      : `/series/${mainSeries.id}`
                  }
                >
                  {img}
                </Link>
              ) : (
                img
              );
            }}
          />
        </section>
        <section
          className="flex flex-col desktop:justify-center mt-4 desktop:pr-4 desktop:mt-0 max-tablet:text-sm"
          itemScope
          itemType="https://schema.org/Person"
        >
          <AuthorMeta />
          <div
            className="flex flex-col gap-4"
            dangerouslySetInnerHTML={{ __html: translate('home.bio') }}
            itemProp="description"
          />
        </section>
      </div>
    </div>
  );
};

export default Home;
